import React from "react";

/**
 * Simplified interactive US map (draft). States are clickable regions.
 * Layout is a compact grid-map, not cartographically precise.
 */
const STATE_GRID = [
  // [code, name, col, row, colspan]
  ["AK", "Alaska", 0, 0, 1],
  ["ME", "Maine", 11, 0, 1],
  ["VT", "Vermont", 10, 1, 1],
  ["NH", "New Hampshire", 11, 1, 1],
  ["WA", "Washington", 1, 2, 1],
  ["ID", "Idaho", 2, 2, 1],
  ["MT", "Montana", 3, 2, 1],
  ["ND", "North Dakota", 4, 2, 1],
  ["MN", "Minnesota", 5, 2, 1],
  ["WI", "Wisconsin", 6, 2, 1],
  ["MI", "Michigan", 7, 2, 1],
  ["NY", "New York", 9, 2, 1],
  ["MA", "Massachusetts", 10, 2, 1],
  ["OR", "Oregon", 1, 3, 1],
  ["NV", "Nevada", 2, 3, 1],
  ["WY", "Wyoming", 3, 3, 1],
  ["SD", "South Dakota", 4, 3, 1],
  ["IA", "Iowa", 5, 3, 1],
  ["IL", "Illinois", 6, 3, 1],
  ["IN", "Indiana", 7, 3, 1],
  ["OH", "Ohio", 8, 3, 1],
  ["PA", "Pennsylvania", 9, 3, 1],
  ["NJ", "New Jersey", 10, 3, 1],
  ["CT", "Connecticut", 11, 3, 1],
  ["CA", "California", 1, 4, 1],
  ["UT", "Utah", 2, 4, 1],
  ["CO", "Colorado", 3, 4, 1],
  ["NE", "Nebraska", 4, 4, 1],
  ["MO", "Missouri", 5, 4, 1],
  ["KY", "Kentucky", 6, 4, 1],
  ["WV", "West Virginia", 7, 4, 1],
  ["VA", "Virginia", 8, 4, 1],
  ["MD", "Maryland", 9, 4, 1],
  ["DE", "Delaware", 10, 4, 1],
  ["RI", "Rhode Island", 11, 4, 1],
  ["AZ", "Arizona", 2, 5, 1],
  ["NM", "New Mexico", 3, 5, 1],
  ["KS", "Kansas", 4, 5, 1],
  ["AR", "Arkansas", 5, 5, 1],
  ["TN", "Tennessee", 6, 5, 1],
  ["NC", "North Carolina", 7, 5, 1],
  ["SC", "South Carolina", 8, 5, 1],
  ["DC", "District of Columbia", 9, 5, 1],
  ["OK", "Oklahoma", 4, 6, 1],
  ["LA", "Louisiana", 5, 6, 1],
  ["MS", "Mississippi", 6, 6, 1],
  ["AL", "Alabama", 7, 6, 1],
  ["GA", "Georgia", 8, 6, 1],
  ["TX", "Texas", 4, 7, 2],
  ["FL", "Florida", 8, 7, 1],
  ["HI", "Hawaii", 0, 7, 1],
];

const CELL = 48;
const GAP = 4;

export default function UsStateMap({ selected, onSelect }) {
  const maxCol = 12;
  const maxRow = 8;
  const width = maxCol * (CELL + GAP) + GAP;
  const height = maxRow * (CELL + GAP) + GAP;

  return (
    <svg
      className="us-state-map"
      viewBox={`0 0 ${width} ${height}`}
      role="img"
      aria-label="United States map — select a state"
    >
      {STATE_GRID.map(([code, name, col, row, colspan]) => {
        const x = GAP + col * (CELL + GAP);
        const y = GAP + row * (CELL + GAP);
        const w = colspan * CELL + (colspan - 1) * GAP;
        const h = CELL;
        const isSel = selected === code;
        return (
          <g
            key={code}
            className={`us-state ${isSel ? "selected" : ""}`}
            onClick={() => onSelect && onSelect(code, name)}
            style={{ cursor: "pointer" }}
          >
            <title>{name}</title>
            <rect
              x={x}
              y={y}
              width={w}
              height={h}
              rx={4}
              fill={isSel ? "#8dc63f" : "#e8eef5"}
              stroke={isSel ? "#5a8f1f" : "#6b7c93"}
              strokeWidth={isSel ? 2 : 1}
            />
            <text
              x={x + w / 2}
              y={y + h / 2 + 4}
              textAnchor="middle"
              fontSize={12}
              fontWeight={600}
              fill={isSel ? "#fff" : "#222"}
            >
              {code}
            </text>
          </g>
        );
      })}
    </svg>
  );
}
